import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TenantSettings } from 'app/shared/types/tenant-settings.types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TenantSettingsQueryService {
    private readonly _http = inject(HttpClient);

    getTenantSettings(): Observable<TenantSettings> {
        return this._http.get<TenantSettings>('api/tenant-settings');
    }
}
